export default {
    strings: {
        // Shown while Assemblies are being created for an upload.
        creatingAssembly: 'Preparing upload...',
        // Shown if an Assembly could not be created.
        creatingAssemblyFailed: 'Transloadit: Could not create Assembly',
        // Shown after uploads have succeeded, but when the Assembly is still executing.
        // This only shows if `waitForMetadata` or `waitForEncoding` was enabled.
        encoding: 'Encoding...',
    },
};
